<template>
  <div class="question-content">
    <v-container fluid grid-list-md>
      <wes-q-text v-bind:metadata="question"></wes-q-text>

      <div id="q15Errs" style="width:100%;height:15px;"></div>
      <err-panel v-if="bDisplayErrors===true" v-on:closepanel="onClosePanel" v-bind:errors="errorList" v-on:closeerrorpanel="onErrorPanelCleared"></err-panel>

      <v-layout row wrap>
        <v-flex xs12>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark :curentAnswer="currentAnswer" @click="onFillZerosClicked(currentAnswer)">Fill With Zeros</v-btn>
          </div>
        </v-flex>
      </v-layout>

      <v-layout v-for="(category, categoryIndex) in this.labels" :key="category.categoryHeading" row wrap>
        <v-flex lg12><hr /><br /></v-flex>

        <!-- COLUMN HEADERS -->
        <!-- CATEGORY HEADER -->
        <v-flex xs8>
          <p class="column-header">{{ colHeaders[0].colLabel }}</p>
        </v-flex>
        <!-- DATA HEADERS -->
        <v-flex v-for="colHeaders in filteredColHeaders" :key="colHeaders.colHeader" xs1>
          <p class="column-header">{{ colHeaders.colHeader }}<br />{{ colHeaders.colLabel }}</p>
        </v-flex>

        <!-- ROWS WITH NO SUBCATEGORIES -->
        <v-layout v-if="category.subs == ''" row wrap>
          <v-flex xs8>
            <p class="row-header">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][0]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 0, $event)"></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(0)" @change="q15Updated(grandRowsTotals(0))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][1]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 1, $event)"></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(1)" @change="q15Updated(grandRowsTotals(1))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field v-model="currentAnswer[categoryIndex].answerFields[0][2]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, 0, 2, $event)"></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandRowsTotals(2)" @change="q15Updated(grandRowsTotals(2))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

          <!-- Not the last category -->
          <v-flex v-if="categoryIndex != labels.length - 1" :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="totalCols(categoryIndex, 0, 3)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>
          <!-- The last category (with totals) -->
          <v-flex v-else :currentAnswer="currentAnswer" xs1>
            <v-text-field :value="grandTotalComputedRows(3)" @change="q15Updated(grandRowsTotals(3))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
          </v-flex>

        </v-layout>

        <!-- ROWS WITH SUBCATEGORIES -->
        <v-layout v-else row wrap>
          <v-flex xs12>
            <p class="row-header">{{ category.categoryHeading }}. {{ category.categoryLabel }}</p>
          </v-flex>
          <v-layout v-for="(dataRows, dataRowsIndex) in category.subs" :key="dataRows.colHeader" row wrap>
            <v-flex xs8>
              <p class="row-label">{{ dataRows.subHeading }}. {{ dataRows.subLabel }}</p>
            </v-flex>

            <v-flex v-if="dataRowsIndex != category.subs.length - 1" :currentAnswer="currentAnswer" xs1>
              <v-text-field v-model="currentAnswer[categoryIndex].answerFields[dataRowsIndex][0]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, dataRowsIndex, 0, $event)"></v-text-field>
            </v-flex>
            <v-flex v-else :currentAnswer="currentAnswer" xs1>
              <v-text-field :value="totalRows(categoryIndex, 0)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>

            <v-flex v-if="dataRowsIndex != category.subs.length - 1" :currentAnswer="currentAnswer" xs1>
              <v-text-field v-model="currentAnswer[categoryIndex].answerFields[dataRowsIndex][1]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, dataRowsIndex, 1, $event)"></v-text-field>
            </v-flex>
            <v-flex v-else :currentAnswer="currentAnswer" xs1>
              <v-text-field :value="totalRows(categoryIndex, 1)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>

            <v-flex v-if="dataRowsIndex != category.subs.length - 1" :currentAnswer="currentAnswer" xs1>
              <v-text-field v-model="currentAnswer[categoryIndex].answerFields[dataRowsIndex][2]" prefix="$" suffix="" height="32" outline @change="updateAnswerValue(categoryIndex, dataRowsIndex, 2, $event)"></v-text-field>
            </v-flex>
            <v-flex v-else :currentAnswer="currentAnswer" xs1>
              <v-text-field :value="totalRows(categoryIndex, 2)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>

            <v-flex v-if="dataRowsIndex != category.subs.length - 1" :currentAnswer="currentAnswer" xs1>
              <v-text-field :value="totalCols(categoryIndex, dataRowsIndex, 3)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>
            <v-flex v-else :currentAnswer="currentAnswer" xs1>
              <v-text-field :value="totalComputedRows(categoryIndex)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
            </v-flex>

          </v-layout>

        </v-layout>
      </v-layout>

      <br /><br />

      <v-layout row wrap>
        <v-flex xs8>
            <p class="row-label">Cross check: totals in row c above should match the amounts from question 8.g, columns 1–5 displayed here.</p>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="grandRowsTotalsCrossCheck(0)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="grandRowsTotalsCrossCheck(1)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="grandRowsTotalsCrossCheck(2)" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
        <v-flex :currentAnswer="crossCheckAnswer" xs1>
            <v-text-field :value="total3(grandRowsTotalsCrossCheck(0), grandRowsTotalsCrossCheck(1), grandRowsTotalsCrossCheck(2))" prefix="$" suffix="" height="32" readonly outline></v-text-field>
        </v-flex>
      </v-layout>

      <br /><br />

      <answer-explain :label="question.explanation.label" v-bind:explaination="x"></answer-explain>

      <v-layout row wrap>
        <v-flex xs2><v-icon class="help-ico" v-on:click="onHandleHelpClicked(true)">fa fa-question-circle</v-icon></v-flex>
        <v-flex xs10>
          <div class="clearfix buttons-container">
            <v-btn class="button" rounded color="primary" dark v-on:click="onSaveClicked">Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <help-panel v-if="bDisplayHelp===true" v-on:closepanel="onClosePanel" v-bind:question="question"></help-panel>
  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { utilityService } from '../../services/utilityService';
import { errorService } from '../../services/errorService';
export default {
  name: 'Question15',
  props: {
    question: Object,
    qId: String
  },
  data: () => ({
    isHelpDisplayed: false,
    isErrorsOverlayDisplayed: false,

    colHeaders: [
      { colHeader: '', colLabel: 'Field of R&D' },
      { colHeader: '(a)', colLabel: 'Basic Research' },
      { colHeader: '(b)', colLabel: 'Applied Research' },
      { colHeader: '(c)', colLabel: 'Experimental Development' },
      { colHeader: '(d)', colLabel: 'Total R&D conduct' }
    ],
    x: '',
    labels: [
      { categoryHeading: 'a',
categoryLabel: 'Computer and information sciences',
        subs: ['']
      },
      { categoryHeading: 'b',
categoryLabel: 'Geosciences, atmospheric sciences, and ocean sciences',
        subs: [
          { subHeading: '1', subLabel: 'Atmospheric science and meteorology' },
          { subHeading: '2', subLabel: 'Geological and earth sciences' },
          { subHeading: '3', subLabel: 'Ocean sciences and marine sciences' },
          { subHeading: '4', subLabel: 'Other geosciences, atmospheric, and ocean sciences' },
          { subHeading: '5', subLabel: 'Total geosciences, atmospheric sciences, and ocean sciences' }
        ]
      },
      { categoryHeading: 'c',
categoryLabel: 'Life sciences',
        subs: [
          { subHeading: '1', subLabel: 'Agricultural sciences' },
          { subHeading: '2', subLabel: 'Biological and biomedical sciences' },
          { subHeading: '3', subLabel: 'Health sciences' },
          { subHeading: '4', subLabel: 'Natural resources and conservation' },
          { subHeading: '5', subLabel: 'Other life sciences' },
          { subHeading: '6', subLabel: 'Total life sciences' }
        ]
      },
      { categoryHeading: 'd',
categoryLabel: 'Mathematics and statistics',
        subs: ['']
      },
      { categoryHeading: 'e',
categoryLabel: 'Physical sciences',
        subs: [
          { subHeading: '1', subLabel: 'Astronomy and astrophysics' },
          { subHeading: '2', subLabel: 'Chemistry' },
          { subHeading: '3', subLabel: 'Materials science' },
          { subHeading: '4', subLabel: 'Physics' },
          { subHeading: '5', subLabel: 'Other physical sciences' },
          { subHeading: '6', subLabel: 'Total physical sciences' }
        ]
      },
      { categoryHeading: 'f',
categoryLabel: 'Psychology',
        subs: [
          { subHeading: '1', subLabel: 'Biological aspects' },
          { subHeading: '2', subLabel: 'Social aspects' },
          { subHeading: '3', subLabel: 'Other psychological sciences' },
          { subHeading: '4', subLabel: 'Total psychology' }
        ]
      },
      { categoryHeading: 'g',
categoryLabel: 'Social sciences',
        subs: [
          { subHeading: '1', subLabel: 'Anthropology' },
          { subHeading: '2', subLabel: 'Economics' },
          { subHeading: '3', subLabel: 'Political science and government' },
          { subHeading: '4', subLabel: 'Sociology, demography, and population studies' },
          { subHeading: '5', subLabel: 'Other social sciences   ' },
          { subHeading: '6', subLabel: 'Total social sciences' }
        ]
      },
      { categoryHeading: 'h',
categoryLabel: 'Engineering',
        subs: [
          { subHeading: '1', subLabel: 'Aerospace, aeronautical, and astronautical engineering' },
          { subHeading: '2', subLabel: 'Bioengineering and biomedical engineering' },
          { subHeading: '3', subLabel: 'Chemical engineering' },
          { subHeading: '4', subLabel: 'Civil engineering' },
          { subHeading: '5', subLabel: 'Electrical, electronics, and communications engineering' },
          { subHeading: '6', subLabel: 'Industrial and manufacturing engineering ' },
          { subHeading: '7', subLabel: 'Mechanical engineering' },
          { subHeading: '8', subLabel: 'Metallurgical and materials engineering' },
          { subHeading: '9', subLabel: 'Other engineering' },
          { subHeading: '10', subLabel: 'Total engineering' }
        ]
      },
      { categoryHeading: 'i',
categoryLabel: 'Other fields',
        subs: [
          { subHeading: '1', subLabel: 'Business management and business administration' },
          { subHeading: '2', subLabel: 'Communication and communications technologies' },
          { subHeading: '3', subLabel: 'Education research' },
          { subHeading: '4', subLabel: 'Humanities' },
          { subHeading: '5', subLabel: 'Law' },
          { subHeading: '6', subLabel: 'Social work' },
          { subHeading: '7', subLabel: 'Visual and performing arts' },
          { subHeading: '8', subLabel: 'All other fields' },
          { subHeading: '9', subLabel: 'Total other fields' }
        ]
      },
      { categoryHeading: 'j',
categoryLabel: 'Total, all fields of R&D conduct',
        subs: ['']
      }
    ],
    currentAnswer: [
      { answerCategory: 'a', answerFields: [['1', '2', '3']] },
      { answerCategory: 'b', answerFields: [['4', '5', '6'], ['7', '8', '9'], ['10', '11', '12'], ['13', '14', '15']] },
      { answerCategory: 'c', answerFields: [['16', '17', '18'], ['19', '20', '21'], ['22', '23', '24'], ['25', '26', '27'], ['28', '29', '30']] },
      { answerCategory: 'd', answerFields: [['31', '32', '33']] },
      { answerCategory: 'e', answerFields: [['34', '35', '36'], ['37', '38', '39'], ['40', '41', '42'], ['43', '44', '45'], ['46', '47', '48']] },
      { answerCategory: 'f', answerFields: [['49', '50', '51'], ['52', '53', '54'], ['55', '56', '57']] },
      { answerCategory: 'g', answerFields: [['58', '59', '60'], ['61', '62', '63'], ['64', '65', '66'], ['67', '68', '69'], ['70', '71', '72']] },
      { answerCategory: 'h', answerFields: [['73', '74', '75'], ['76', '77', '78'], ['79', '80', '81'], ['82', '83', '84'], ['85', '86', '87'], ['88', '89', '90'], ['91', '92', '93'], ['94', '95', '96'], ['97', '98', '99']] },
      { answerCategory: 'i', answerFields: [['100', '101', '102'], ['103', '104', '105'], ['106', '107', '108'], ['109', '110', '111'], ['112', '113', '114'], ['115', '116', '117'], ['118', '119', '120'], ['121', '122', '123']] },
      { answerCategory: 'j', answerFields: [] }
    ],
    crossCheckAnswer: [
      { answerCategory: 'a', answerFields: [['1', '2', '3']] },
      { answerCategory: 'b', answerFields: [['4', '5', '6']] },
      { answerCategory: 'c', answerFields: [['7', '8', '9']] },
      { answerCategory: 'd', answerFields: [['10', '11', '12']] },
      { answerCategory: 'e', answerFields: [['13', '14', '15']] },
      { answerCategory: 'f', answerFields: [['16', '17', '18']] },
      { answerCategory: 'g', answerFields: [['19', '20', '21']] },
      { answerCategory: 'h', answerFields: [['22', '23', '24']] },
      { answerCategory: 'i', answerFields: [['25', '26', '27']] },
      { answerCategory: 'j', answerFields: [['', '', '']] }
    ]
  }),
  methods: {
    q15Updated: function (val) {
      // this.$emit("q15Totals", val);
    },
    onFillZerosClicked: function () {
      const categories = this.currentAnswer.length;
      for (var i = 0; i < categories; i++) {
        const rowsInCategory = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < rowsInCategory; j++) {
          const columns = this.currentAnswer[i].answerFields[j].length;
          for (var k = 0; k < columns; k++) {
            if (this.currentAnswer[i].answerFields[j][k] === '') {
              this.currentAnswer[i].answerFields[j][k] = '0';
              this.currentAnswer.push();
              // console.log('categories=' + categories + ' rowsInCategory=' + rowsInCategory + ' columns=' + columns)
            }
          }
        }
      }
    },
    updateAnswerValue: function (id, idx, item, val) {
      this.currentAnswer[id].answerFields[idx][item] = val;
    },
    onValueChanged: function (event) {
      console.log('On Value Changed.');
    },
    onSaveClicked: function () {
      console.log('Called save with: ' + this.currentAnswer);
      answerService.saveSurveyQuestionAnswer(0, this.$props.question.id, this.currentAnswer);
      this.errorList = errorService.runValidationForQuestion(this.$props.question.id);
      this.isErrorsOverlayDisplayed = true;
      utilityService.scrollElemIntoView('q15Errs');
    },
    onClosePanel: function () {
      this.isErrorsOverlayDisplayed = false;
      this.isHelpDisplayed = false;
    },
    onErrorPanelCleared: function () {
      this.isErrorsOverlayDisplayed = false;
    },
    onHandleHelpClicked: function (bDisplay) {
      this.isHelpDisplayed = bDisplay;
    },
    totalCols: function (category, subcategory, colTotal) {
      var total = 0;
      // console.log("one=" + one + ", two=" + two + ", three=" + three);
      var totalCols = colTotal;
      for (var i = 0; i < totalCols; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[subcategory][i])
      }
      return total;
    },
    totalRows: function (category, colIndex) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][colIndex])
      }
      return total;
    },
    totalComputedRows: function (category) {
      var total = 0;
      var totalRows = this.currentAnswer[category].answerFields.length;
      for (var i = 0; i < totalRows; i++) {
        var totalCols = this.currentAnswer[category].answerFields[i].length;
        for (var j = 0; j < totalCols; j++) {
          // console.log("i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
          total += utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]);
        }
      }
      return total;
    },
    grandTotalComputedRows: function () {
      var total = 0;
      var totalCategories = this.currentAnswer.length;
      for (var h = 0; h < totalCategories; h++) {
        var totalRows = this.currentAnswer[h].answerFields.length;
        for (var i = 0; i < totalRows; i++) {
          var totalCols = this.currentAnswer[h].answerFields[i].length;
          for (var j = 0; j < totalCols; j++) {
            // console.log("h=" + h + ", i=" + i + ", j=" + j + ", total=" + utilityService.convertStringToNum(this.currentAnswer[category].answerFields[i][j]));
            total += utilityService.convertStringToNum(this.currentAnswer[h].answerFields[i][j]);
          }
        }
      }
      return total;
    },
    grandRowsTotals: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.currentAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.currentAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.currentAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    grandRowsTotalsCrossCheck: function (col) {
      var total = 0;
      const colIndex = col;
      var totalCategories = this.crossCheckAnswer.length;
      for (var i = 0; i < totalCategories; i++) {
        var totalSubs = this.crossCheckAnswer[i].answerFields.length;
        for (var j = 0; j < totalSubs; j++) {
          total += utilityService.convertStringToNum(this.crossCheckAnswer[i].answerFields[j][colIndex])
        }
      }
      return total;
    },
    total3: function (num1, num2, num3) {
      return num1 + num2 + num3;
    },
    getValues: function (val1, val2) {
      console.log("Val1=" + val1 + " Val2=" + val2);
    }
  },
  computed: {
		bDisplayHelp: function () {
			return this.isHelpDisplayed;
		},
		bDisplayErrors: function () {
			return this.isErrorsOverlayDisplayed;
    },
    filteredColHeaders () {
      return this.colHeaders.slice(1, 5);
    }
  }
};
</script>

<style scoped>
.header {
  font-weight: bold;
}
.column-header {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}
.row-header {
  line-height: 20px;
  margin: 20px 0px 40px 5px;
  font-weight: bold;
  font-size: 24px;
}
.question-content {
  text-align: left;
  /* background-color: #598dc233; */
  /* border: 2px solid #13314f; */
  /* border-radius: 5px; */
  /* position: relative; */
  color: black;
}
.question-content > h1 {
  margin: 5px 0;
}
.question-content > p,
.question-content > ul {
  margin: 5px 10px;
}
.value-list {
  list-style: lower-latin;
}
.row-label {
  line-height: 60px;
  margin: 0px 0px 0px 20px;
  font-weight: bold;
  font-size: 18px;
}
.buttons-container > .button {
  float: right;
}
.v-text-field--outline > .v-input__control > .v-input__slot {
  background-color: purple;
}
.v-input--is-focused > .v-input__control > .v-input__slot {
  border: 2px solid red;
}
.help-ico {
  font-size: 40px;
  line-height: 44px;
  color: #0000ffa3;
}
.bordered {
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.3);
  border-width: 1px 1px 1px 2px;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
</style>
